// FILE: src/components/SupportPromptDialog.jsx
// Shown when the server reports a locked account (MTO 1.3 / 1.3.4): tells the
// student how to reach support and settles the request that triggered it.
// Escape and "Close" both dismiss it (README rule 11).
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, Stack } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useDispatch, useSelector } from "react-redux";
import { dismissSupport } from "../features/supportPromptSlice";
import useSupportChannels from "../hooks/useSupportChannels";
import SupportContactList from "./SupportContactList";
import IconDialogTitle from "./student/IconDialogTitle";

export default function SupportPromptDialog() {
  const { show, reason } = useSelector((s) => s.supportPrompt);
  const dispatch = useDispatch();
  const channels = useSupportChannels(Boolean(show));

  const close = () => dispatch(dismissSupport());

  return (
    <Dialog
      open={Boolean(show)}
      onClose={close}
      fullWidth
      maxWidth="sm"
      aria-labelledby="support-prompt-title"
      aria-describedby="support-prompt-description"
    >
      <IconDialogTitle id="support-prompt-title" icon={LockOutlinedIcon} tone="error">
        Your account is locked
      </IconDialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <DialogContentText id="support-prompt-description" sx={{ color: "text.primary" }}>
            {reason} For your security, only student support can unlock it.
          </DialogContentText>
          <SupportContactList channels={channels} />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button variant="contained" onClick={close} autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
